export default function Social({ social }) {
  const socialItems = [
    { name: 'LinkedIn', key: 'linkedinUrl' },
    { name: 'Github', key: 'githubUrl' },
  ];

  if (!social) return null;

  return (
    <div
      style={{
        backgroundColor: 'var(--card-background, #fff)',
        borderRadius: 16,
        padding: '20px 24px',
        border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
        boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
      }}
    >
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--heading-primary, #111827)', marginBottom: 12 }}>
            Social Accounts
          </div>

          {socialItems.map((item, index) => (
            <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: 'var(--text-secondary, #6B7280)', minWidth: 60 }}>{item.name}:</span>
              <a
                href={social[item.key]}
                target='_blank'
                rel='noreferrer'
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'var(--primary-main, #4F46E5)',
                  wordBreak: 'break-all',
                }}
              >
                {social[item.key]}
              </a>
            </div>
          ))}
    </div>
  );
}
